import {EntityBase} from "../../../shared/entity/EntityBase";

const BADGE_MASTER_TABLE_FIELDS = {
    index: { type: Number, defaultValue: 0 },
    name: { defaultValue: '' },
}

export class BadgeMasterTableEntity extends EntityBase {
    constructor(data = {}) {
        super(data, BADGE_MASTER_TABLE_FIELDS);

        this.errors = [
            {condition: () => this.index === 0, message: '인덱스가 없습니다.'},
        ];
    }
}